import { css } from '@emotion/react';

import useTheme from '../../hooks/useTheme';

export default () => {
  const { breakpoints, colors } = useTheme();
  return {
    listWrapper: css`
      width: 100%;
    `,
    chooseFilter: css`
      display: flex;
      justify-content: space-between;
      gap: 1rem;
      align-items: center;
      padding: 8px 8px 8px 12px;
      border-radius: 80px;

      span {
        color: #5b6885;
        letter-spacing: 0.32px;
      }
      &:hover {
        background-color: #eceef3;
      }
    `,
    mixedCheckbox: css`
      position: absolute;
      opacity: 0;
      width: 1px;
      height: 1px;
      padding: 0;
      margin: -1px;
      overflow: hidden;
      clip: rect(0, 0, 0, 0);
      white-space: nowrap;
      border-width: 0;

      & + span {
        width: 1.5rem;
        height: 1.5rem;
        border-radius: 100%;
        color: #5b6885;
        border: 2px solid currentColor;
        display: flex;
        align-items: center;
        justify-content: center;
        transition: border-color 0.3s ease;
      }

      &:checked + span {
        color: #00539f;
        background-color: #fff;
      }

      &:checked + span::after {
        content: '';
        width: 0.25rem;
        height: 0.625rem;
        border: solid currentColor;
        border-width: 0 2px 2px 0;
        transform: rotate(45deg);
        position: relative;
        display: block;
        margin-top: -3px;
      }
    `,

    radioButtons: css`
      display: flex;
      padding: 4px;
      border-radius: 40px;
      border: 1px solid #bbc1ce;
      width: 100%;
      justify-content: space-between;
      text-align: center;
      align-items: center;
    `,
    radioInput: css`
      position: absolute;
      opacity: 0;
      width: 1px;
      height: 1px;
      padding: 0;
      margin: -1px;
      overflow: hidden;
      clip: rect(0, 0, 0, 0);
      white-space: nowrap;
      border-width: 0;

      ${breakpoints.s} {
        &:focus-visible + label {
          border: 2px solid ${colors.border_black}; /* Solid black border for keyboard focus */
          outline: 2px solid ${colors.skip_yellow}; /* Yellow outline for contrast */
        }
      }
    `,
    radioLabel: css`
      padding: 6px 22px;
      border-radius: 40px;
      cursor: pointer;
      transition: background-color 0.3s, color 0.3s, border-color 0.2s;
      flex: 1;
      white-space: nowrap;
      border: 2px solid transparent;
      @media (hover: hover) and (pointer: fine) {
        &:hover {
          background-color: ${colors.navy};
          span {
            color: white;
          }
        }
      }
    `,
    radioLabelChecked: css`
      background-color: #00539f;
      span {
        color: white;
      }
    `,
    labelText: css`
      color: #5b6885;
      font-family: 'FS Dillon';
      font-size: 16px;
      font-style: normal;
      font-weight: 400;
      line-height: 20px;
      letter-spacing: 0.32px;
    `,
    mixedOptions: isMixed => css`
      position: relative; // Needed for positioning the hidden checkbox
      display: flex;
      padding: 8px 8px 8px 12px;
      align-items: center;
      gap: 10px;
      align-self: stretch;
      border-radius: 80px;
      justify-content: space-between;
      cursor: pointer;

      &:hover {
        background-color: #eceef3;
      }
      ${breakpoints.s} {
        &:has(input:focus-visible) {
          border: 2px solid ${colors.border_black};
          outline: 2px solid ${colors.skip_yellow};
        }
      }

      label {
        color: #5b6885;
        letter-spacing: 0.32px;
      }

      ${isMixed &&
      css`
        background-color: #eceef3;
      `}
    `,
  };
};
